import { ReactNode } from 'react';
import { Link, LinkProps as MuiLinkProps } from '@mui/material';

type TExternalLinkProps = Omit<MuiLinkProps, 'component'> & {
  to?: string; // defines the href attr as well
  children?: ReactNode;
};

const ExternalLink = ({ to = '#', children, sx, ...rest }: TExternalLinkProps) => {
  return (
    <Link
      href={to}
      target="_blank"
      rel="noreferrer noopener"
      sx={{ '&:hover': { textDecoration: 'underline' }, ...sx }}
      {...rest}
    >
      {children ?? ''}
    </Link>
  );
};

export default ExternalLink;
